import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b2a1c34")

_pushScopeId("data-v-4b2a1c34")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "toiawase-form" }
const _hoisted_4 = { class: "kaito-form" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 送信")
const _hoisted_6 = { class: "dialog-title" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-warning" }, null, -1)
const _hoisted_8 = { class: "confirm-content" }
const _hoisted_9 = { class: "confirm-msg" }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = { class: "btns" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 送信")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 更新")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" キャンセル")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_panel = _resolveComponent("cus-panel")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_cus_panel, { title: "問い合わせ記入欄" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_el_form, {
              model: _ctx.panels.toiawaseForm,
              rules: _ctx.toiawaseFormRules,
              ref: "toiawaseFormRef",
              size: "small",
              "label-position": "top"
            }, {
              default: _withId(() => [
                (_ctx.isExitedToiawase)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "問い合わせID",
                      prop: "toiawaseId"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.panels.toiawaseForm.toiawaseId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.panels.toiawaseForm.toiawaseId = $event)),
                          id: "toiawaseId",
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isExitedToiawase)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "登録日時",
                      prop: "itakusakiJusho"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.panels.toiawaseForm.createdDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.panels.toiawaseForm.createdDate = $event)),
                          id: "createDate",
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "氏名",
                  prop: "kjnNm"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.toiawaseForm.kjnNm,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.panels.toiawaseForm.kjnNm = $event)),
                      id: "kjnNm",
                      disabled: _ctx.isExitedToiawase
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "会社名",
                  prop: "kaishaNm"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.toiawaseForm.kaishaNm,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.panels.toiawaseForm.kaishaNm = $event)),
                      id: "kaishaNm",
                      disabled: _ctx.isExitedToiawase
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "メールアドレス",
                  prop: "email"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.toiawaseForm.email,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.panels.toiawaseForm.email = $event)),
                      disabled: _ctx.isExitedToiawase
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "お問い合わせ件名",
                  prop: "toiawaseKenmei",
                  class: "entire-row"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.panels.toiawaseForm.toiawaseKenmei,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.panels.toiawaseForm.toiawaseKenmei = $event)),
                      id: "toiawaseKenmei",
                      disabled: _ctx.isExitedToiawase
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "お問い合わせ内容",
                  prop: "toiawaseNaiyo",
                  class: "entire-row"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: { minRows: 6 },
                      modelValue: _ctx.panels.toiawaseForm.toiawaseNaiyo,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.panels.toiawaseForm.toiawaseNaiyo = $event)),
                      id: "toiawaseNaiyo",
                      disabled: _ctx.isExitedToiawase
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }),
      (_ctx.isExitedToiawase)
        ? (_openBlock(), _createBlock(_component_cus_panel, {
            key: 0,
            title: "Ultmarc記入欄"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_el_form, {
                  model: _ctx.panels.kaitoForm,
                  size: "small",
                  "label-position": "top"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "対応状況",
                      prop: "toiawaseJokyo",
                      class: "entire-row"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.panels.kaitoForm.toiawaseJokyoCd,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.panels.kaitoForm.toiawaseJokyoCd = $event)),
                          id: "toiawaseJokyo",
                          "popper-class": "toiawase-jokyo"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.toiawaseJokyoOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.toiawase_jokyo,
                                value: item.toiawase_jokyo_cd
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "回答内容",
                      prop: "kaitoNaiyo",
                      class: "entire-row"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          autosize: { minRows: 6 },
                          modelValue: _ctx.panels.kaitoForm.kaitoNaiyo,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.panels.kaitoForm.kaitoNaiyo = $event)),
                          id: "kaitoNaiyo",
                          disabled: _ctx.isAnswered.answered
                        }, null, 8, ["modelValue", "disabled"]),
                        _createVNode(_component_el_button, {
                          class: "toggle-dialog-btn",
                          type: "primary",
                          size: "mini",
                          plain: "",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmDialogVisible = true)),
                          disabled: _ctx.isAnswered.answered
                        }, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "担当者名",
                      prop: "tantoNm"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.panels.kaitoForm.tantoNm,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.panels.kaitoForm.tantoNm = $event)),
                          disabled: true,
                          id: "tantoNm"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "更新日時",
                      prop: "updatedDate"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.panels.kaitoForm.updatedDate,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.panels.kaitoForm.updatedDate = $event)),
                          disabled: true,
                          id: "updatedDate"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_dialog, {
                  "custom-class": "confirm-dialog",
                  modelValue: _ctx.confirmDialogVisible,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmDialogVisible = $event)),
                  width: "768px"
                }, {
                  title: _withId(() => [
                    _createVNode("span", _hoisted_6, [
                      _hoisted_7,
                      _createVNode("span", null, _toDisplayString(_ctx.ConfirmText.TITLE), 1)
                    ])
                  ]),
                  footer: _withId(() => [
                    _createVNode("span", _hoisted_10, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.confirmDialogVisible = false))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.ConfirmText.NO), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "send-btn",
                        size: "small",
                        type: "primary",
                        loading: _ctx.loadings.sendBtn,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSendKaito()))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.ConfirmText.YES), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode("p", _hoisted_8, _toDisplayString(_ctx.panels.kaitoForm.kaitoNaiyo), 1),
                    _createVNode("p", _hoisted_9, _toDisplayString(_ctx.ComfirmMsg.CFM_SEND_KAITO), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", null, [
        (!_ctx.isExitedToiawase)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "create-btn",
              type: "primary",
              size: "medium",
              plain: "",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleCreate())),
              loading: _ctx.loadings.createBtn
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["loading"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "update-btn",
              type: "primary",
              size: "medium",
              plain: "",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleUpdate())),
              loading: _ctx.loadings.updateBtn
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["loading"]))
      ]),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "cancel-btn",
          size: "medium",
          plain: "",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleCancel()))
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ]))
})